import type { RouteApi } from '~/schema/RouteApiSchema'

export const API_USER_SWITCH: RouteApi = {
  method: HttpMethod.GET,
  path: '/user-switch'
}
